export const SOFTLINE_API_LAGER_PALETTENKORREKTUR = '/v1/palettenkorrektur';
export const SOFTLINE_API_LAGER_SCAN_PALLET =
  '/v1/lagerplatzinhalt/scan-palette/{{code}}';
